module.exports = {
      id: "green-sale-usage",
      viewBox: "0 0 36 20",
      url: __webpack_public_path__ + "sprite-b16b2d73f82c96a320ba0490c6416430.svg#green-sale",
      toString: function () {
        return this.url;
      }
    }